const endpoints = {
  profileData: 'api/v2/users/user-id',
  profileUpdate: 'Api/profile',
  profilePasswordUpdate: 'Api/profile',
}

export default endpoints
